import React, { useEffect, useState } from 'react';
import { Modal } from '@riac/design-system';
import { PhoneForm } from 'src/pages/AccountPage/components/PhoneForm';
import { ISelectedPhone } from 'src/pages/AccountPage/PhoneBook/PhoneBook';

export const AddPhoneModal = ({ onConfirm, onReject }) => {
  const [phoneAction, setPhoneAction] = useState<string>('create');
  const [selectedPhone, setSelectedPhone] = useState<ISelectedPhone>({
    phoneNum: '',
    phoneID: 0,
    PhoneTypeID: 0,
    verifiedID: 0,
    ext: '',
  });

  useEffect(() => {
    if(phoneAction === 'done') {
      onConfirm(true);
    } else if(!phoneAction) {
      onReject(false);
    }
  }, [phoneAction]);

  return (<Modal
    isOpen = {true}
    title = {'Add Phone Number'}
    onClose = {() => onReject(false)}
    showCloseButton
    isDismissable
  >
    <div style={{ width: '100%', maxWidth: '540px', maxHeight: '750px', marginBottom: '3em' }}>
      <h5 className='my-4 text-red-700'>A Phone number is required for RIAC on Time</h5>
      <PhoneForm
        phones={[]}
        phoneAction={phoneAction}
        setPhoneAction={setPhoneAction}
        selectedPhone={selectedPhone}
        setSelectedPhone={setSelectedPhone}
        getPhones={() => null}
      /></div>
  </Modal>);
};
